import React from 'react';
import { Button, IconButton, Stack } from '@mui/material';
import { MenuButton } from 'ui';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useApi, useModalContext } from 'hooks';
import { LoadingButton } from '@mui/lab';

interface VideoEditDropdownProps {
    videoId: string;
    title: string;
    channelId: string;
}

interface ConfirmDialogProps {
    videoId: string;
    channelId: string;
    close: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = (props) => {
    const { api } = useApi();
    const deleteVideo = api.useMutation('delete', '/media/{id}');
    const submit = () => {
        deleteVideo
            .mutateAsync({
                params: {
                    path: {
                        id: props.videoId,
                    },
                },
            })
            .then(() => props.close());
    };
    return (
        <Stack direction="row" justifyContent="space-between">
            <LoadingButton loading={deleteVideo.isPending} onClick={submit}>
                Yes
            </LoadingButton>
            <Button disabled={deleteVideo.isPending} onClick={props.close}>
                No
            </Button>
        </Stack>
    );
};

const VideoEditDropdown: React.FC<VideoEditDropdownProps> = (props) => {
    const modalContext = useModalContext();

    const deleteVideo = (title: string, videoId: string, channelId: string) => {
        modalContext.hideModal();
        modalContext.showModal({
            title: `Delete ${title}`,
            open: true,
            children: (
                <ConfirmDialog
                    channelId={channelId}
                    videoId={videoId}
                    close={modalContext.hideModal}
                />
            ),
        });
    };
    return (
        <IconButton
            data-cy=""
            style={{ paddingTop: '0px', paddingBottom: '0px' }}
            size="large"
            color="inherit"
        >
            <MenuButton
                IconProps={{
                    size: 'large',
                    edge: 'end',
                    color: 'inherit',
                }}
                menuId={'test'}
                menuItems={[
                    {
                        title: 'Delete',
                        onClick: () =>
                            deleteVideo(
                                props.title,
                                props.videoId,
                                props.channelId,
                            ),
                    },
                ]}
            >
                <MoreHorizIcon />
            </MenuButton>
        </IconButton>
    );
};

export default VideoEditDropdown;
